<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style="position:absolute;visibility:hidden;height:0;pointer-events:none;z-index:-1; "
  >
    <symbol id="live-receptionist" width="88" height="88" viewBox="0 0 88 88" fill="none">
      <path
        d="M61.453 28.699c4.363-2.579 11.662-9.996 5.95-19.04-7.14-11.305-14.28-2.38-17.85-1.19-3.57 1.19-5.95-5.95-10.71-2.975-4.76 2.975-2.38 12.495-13.09 18.445-7.468 4.148-6.258 16.974 0 24.966"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M52.528 70.349c-.953-1.904-.397-4.76 0-5.95 5.751-.397 16.422-5.593 13.09-23.205-2.856-10.948-7.14-17.652-8.925-19.635-.595.991-2.975 3.689-7.735 6.545-5.2 3.12-10.853 5.33-11.403 11.396M48.958 79.274c-4.76 1.19-9.52-1.19-10.115-5.355-.595-4.165.595-11.305-1.19-15.47-.292-.681-.565-1.333-.818-1.949M38 72.034c-10.5 5-21.5 7-23 11.5m41-11c12.5 4 15.5 5 16.5 8"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <ellipse
        cx="34.084"
        cy="47.739"
        rx="8.33"
        ry="8.925"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M41.818 51.904c1.785 1.19 5.95 1.785 12.495-.595m0 0c-1.19-3.57 5.355-5.95 6.545-3.57 1.19 2.38-2.974 7.14-6.544 3.57zM31.11 19.773c-2.131 2.976-4.648 15.808-1.191 20.23"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>

    <symbol id="group-mail" width="88" height="88" viewBox="0 0 88 88" fill="none">
      <path
        d="M70.494 29.124c0-3.534.001-4.7-6.767-5.354-11.053-1.068-19.819-.483-29.487 1.25-4.834.867-6.126 1.185-4.834 7.854.294 1.517.587 5.03.556 9.061"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M62.182 23.043c0-3.626 0-4.822-6.767-5.493-11.053-1.096-19.82-.495-29.487 1.283-4.834.889-6.127 1.215-4.834 8.057.484 2.566.966 10.692 0 17.602-.372 2.652-.296 3.515 2.852 4.716"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M38.586 49.856c.186-5.676.294-11.86-.294-16.543-.595-4.742 45.709-5.498 45.709 0v26.914c0 4.13-38.88 4.829-44.924 1.05"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M38.286 32.584l16.31 16.863m28.366-16.052c-4.8 3.963-14.298 12.723-17.873 16.052-2.381 2.218-4.748 2.097-6.454 1.358M41.402 52.325c.458-.495 4.029-4.176 7.273-7.273M84 54.403l-9.35-9.35M27.382 39.055c-.647-.816-.995 1.489-1.137 10.331-7.881 1.3-23.093 2.9-18.835-9.876C-5.366 62.63 21.532 60.207 26.245 60.207c.696 5.458 0 10.331 0 10.331l18.276-15.01S30.978 43.59 27.381 39.054z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>

    <symbol id="additional-recipients" width="88" height="88" viewBox="0 0 88 88" fill="none">
      <path
        d="M54.347 54.079s.641 3.889.641 6.05l-5.394 2.593M71.835 28.26c3.226-1.906 8.622-7.39 4.399-14.076-5.279-8.358-10.558-1.76-13.197-.88-2.64.88-4.4-4.4-7.918-2.2-2.776 1.735-2.268 6.478-5.812 10.564"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M56.075 32.138c1.662-1.732 4.156-2.898 6.523-4.318 3.52-2.111 5.279-4.105 5.719-4.839 1.32 1.467 4.487 6.423 6.598 14.517 2.464 13.021-5.425 16.863-9.678 17.156-.293.88-.704 2.991 0 4.399 9.242 2.957 13.028 6.75 13.767 8.967M34.473 46.257c3.3 1.27 6.79 13.668 2.184 21.193-4.607 7.525-19.359 5.43-23.05-2.142-3.693-7.573 6.797-14.792 6.032-22.334-.764-7.542 1.488-16.009 9.505-20.807 8.016-4.798 18.357-.834 21.216 2.564 2.287 2.72 1.471 3.76.342 5.674-1.94 3.292-5.803 6.405-12.257 5.805"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M36.27 37.626c-.49-.128-4.18-1.171-5.726 2.091-2.084 4.4 3.007 7.813 6.29 6.083M51.093 30.875c1.89 4.886 4.976 14.92 1.106 21.075-2.305 3.666-5.55 5.284-8.383 5.872-1.925.4-3.66.324-4.783.09M14.736 67.493l-6.178 4.355M43.977 58.4c-.864 3.889-3.458 5.617 1.949 7.056 4.069 1.083 7.428 2.297 10.105 3.758"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>

    <symbol id="agent-service" width="88" height="88" viewBox="0 0 88 88" fill="none">
      <path
        d="M42.869 36.071c.246.369 1.106.885 2.58 0m-2.58 0c-1.843-1.106-7.004-2.949-13.271-.737m13.27.737c-1.105 4.793-.736 7.742-6.635 7.742-5.898 0-6.635-2.212-6.635-8.479m15.851.737c1.843-1.106 7.004-2.949 13.271-.737m-13.27.737c1.105 4.793.737 7.742 6.635 7.742s6.635-2.212 6.635-8.479m0 0h5.161m-34.283 0H26.28M58.803 11.563c-.36.863-1.737 2.406-2.55 2.974M59.224 17.5c2.826 2.703 5.836 8.028 4.657 17.465"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M26.28 42.338c-5.53-5.16-5.16-30.228 11.944-31.334C53.164 10.038 53.067 6.212 53.19 4M56.777 7c-.478 1.357-1.947 4.296-4.003 5.201M26.616 32.016c-1.119 8.644-.074 26.433 13.055 28.44"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.93 57.82c-.928 3.608-1.934 7.37 0 11.251-4.794 3.864-7.374 4.233-10.323 4.851-2.95-.618-7.532-3.205-9.585-5.41m0 0c-3.009.95-1.25 5.343-2.57 13.251-.644 3.863 2.197-2.636 8.787-6.15m-6.217-7.102c.989-2.532 1.327-6.93.737-9.584M28.816 72.098C23.984 74.148 13 80.885 13 80.885M55.616 70.34c7.47 1.758 19.331 10.544 19.331 10.544"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M43.723 74c4 1 12.864 13.425 11.422 8.62C53.828 78.226 57.782 69 53.828 69M48.398 52.291c-1.106.37-2.506 1.106-3.686 1.106"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>

    <symbol id="custom-service" fill="none" viewBox="0 0 82 86" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.486 26.872c3.426-2.41 7.835-5.476 12.422-8.635m61.067 7.039c-.472-.584-4.268-3.263-9.228-6.622M29.334 8.416c5.944-3.985 10.397-6.86 10.796-6.832.422.03 3.979 2.37 9.554 5.966M3.521 84.415c5.183-4.672 17.028-15.432 22.941-21.092M80.372 76.769C76.08 73.042 65.358 64.5 56.793 60.153" stroke="#8E8BAA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M18.61 41.13c-1.685-10.393-4.857-31.284-4.066-31.707.99-.53 49.985-2.507 51.193-2.287.967.176 1.209 19.481 1.209 29.112" stroke="#8E8BAA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3.235 84.077c-2.453-8.775-1.56-41.729-.807-57.108 11.293 10.11 35.169 30.554 40.331 31.458 5.163.903 24.306-21.724 33.233-33.15 1.42 10.648 3.388 39.12 4.194 52.025-18.842-.388-59.152 4.355-76.951 6.775ZM24.652 21.337c3.239-.875 6.311-2.208 14.216-1.315" stroke="#8E8BAA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M25.634 30.856c3.24-.876 11.693-2.403 19.598-1.51 7.906.893 12.85-1.466 14.335-2.758" stroke="#8E8BAA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </symbol>

    <symbol id="notarize-document" width="88" height="88" viewBox="0 0 88 88" fill="none">
      <path
        d="M62 51.344c6.189 4.558 14.12 7.48 16.407 7.212C67.55 64.389 44.67 77.61 36.116 78c-16.529-8.75-27.71-28.68-21.39-56.389C24.935 17.884 46.906 9.944 53.13 8c0 10.08-1.814 27.053 2.708 36.5"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M61.69 51.296l-7.336-4.415m7.337 4.415l-8.92 6.09 1.583-10.505m7.337 4.415l12.835-21.328M54.354 46.88l12.835-21.329m0 0l1.673-2.78a4.282 4.282 0 1 1 7.337 4.415l-1.673 2.78m-7.337-4.415l7.337 4.416M21.685 32.306c5.185-1.135 17.208-4.278 23.819-7.778M23.408 43c5.185-1.134 17.209-4.278 23.82-7.778"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M41.012 60.75c.836 3.634-.493 9.042-4.241 8.573-3.935-.491.138-6.89 4.241-8.573z"
        fill="#F6F4FB"
      />
      <path
        d="M33.595 62.337c.847-2.117 3.176-5.97 5.716-4.446 3.176 1.905 2.541 12.068-2.54 11.432-5.082-.635 3.194-11.122 7.64-8.58 6.076 4.253 7.048 2.009 8.385-2.852"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>

    <symbol id="notifications-service" width="88" height="88" viewBox="0 0 88 88" fill="none">
      <path
        d="M63 60.5v6.119c0 5.657 0 8.485-1.757 10.243-1.758 1.757-4.586 1.757-10.243 1.757H37c-5.657 0-8.485 0-10.243-1.757C25 75.104 25 72.276 25 66.619V26.381c0-5.657 0-8.485 1.757-10.243 1.758-1.757 4.586-1.757 10.243-1.757h14c5.657 0 8.485 0 10.243 1.757C63 17.896 63 20.724 63 26.381V32M25 22.418c5.73-.603 21.352-1.447 38 0M25 71.381c5.73.603 21.352 1.448 38 0"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M79.454 35.14c0-4.49-39.963-3.872-39.45 0 .858 6.465 0 16.436 0 21.98.001 4.02 39.45 3.656 39.45 0V35.14z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M40 34.545l15.273 13.772c1.909 1.501 5.599 1.811 7.634 0 3.055-2.72 11.173-9.873 15.275-13.11M41.273 52.363c.395-.381 6.104-5.25 8.909-7.636M79.455 52.363l-7.637-7.636"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>

    <symbol id="deposit-service" width="88" height="88" viewBox="0 0 88 88" fill="none">
      <g
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          d="M3.77 74.467C3.336 53.214 6.968 44.03 9.74 40.192c2.243-3.104 7.54-6.99 11.379-9.296m-1.516 46.173s6.367-2.426 11.71-10.843c1.598-2.518 2.343-8.056 7.155-14.313 4.811-6.256 4.22-9.1 1.3-9.975-4.337-1.301-6.863 6.98-13.878 11.276-1.992 1.436-5.205 3.904-6.94 7.374M19.889 51.66c.26 1.45 1.327 3.796 1.951 4.745M19.384 47.142c.78-1.977.867-3.904.505-6.198 1.103-.559 1.674-1.248 2.53-2.043"
        />
        <path
          d="M26.584 51.946c-3.394-7.212-6.043-24.322-6.76-28.767 19.442-3.703 50.441-9.707 55.945-9.433 5.001 10.497 9.103 29.87 8.698 30.247-.319.298-28.06 6.152-46.776 9.511M29.931 34.088c6.361-.998 18.827-3.293 23.43-4.338M69.861 38.907l6.123-1.307M59.669 41.391l6.122-1.307M49.061 43.901l6.123-1.307"
        />
        <path
          d="M58.99 28.47l-.952-4.134 12.09-2.313c.035.854.527 2.546 1.05 4.137-.556.46-7.788 1.706-12.188 2.31z"
        />
      </g>
    </symbol>
    <symbol id="invoice-with-company-name-service" width="88" height="88" viewBox="0 0 88 88" fill="none">
      <path
        d="M28.5651 32.9998C29.3651 20.9998 25.8984 17.3331 24.0651 16.9998C23.209 16.5998 21.7084 18.1664 21.0651 18.9998L20.0651 21.9998L17.5651 31.9998C16.8984 32.6664 14.5651 34.8 12.5651 36C14.5651 36.8 23.8984 36.8331 28.0651 36.9998C28.2317 36.8331 28.5651 35.7997 28.5651 32.9998Z"
        fill="currentColor"
      />
      <path
        d="M24.065 17C26.065 17.001 57.4327 16.8435 72.9327 17.0102C83.4327 19.5103 81 46.5 78.5 57C76.5 65.4 78.0993 74.3434 79.4327 78.51C65.9327 83.01 33.3327 81.51 28.9327 81.51C23.4327 81.51 24.4327 65.01 25.9327 52.51C27.4327 40.01 31.565 19.4998 24.065 17Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.4327 17.011C22.5994 16.6776 20.6327 17.0117 19.4327 23.0117C17.9327 30.5117 16.9327 35.5108 12.4327 35.0108C7.9327 34.5108 7.4327 12.0108 8.4327 9.01077C11.9327 9.01077 41.9327 8.51077 49.4327 8.01077C56.9327 7.51077 59.9327 6.01077 60.4327 8.01077C60.8327 9.61077 60.5994 14.6776 60.4327 17.011"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M70.1137 65.8815C70.1137 66.9439 69.755 67.8407 69.0375 68.572C68.3201 69.3032 67.4026 69.793 66.285 70.0414V71.3245C66.285 71.6833 66.1608 71.9799 65.9125 72.2145C65.6779 72.4628 65.3813 72.587 65.0225 72.587C64.6776 72.587 64.3879 72.4628 64.1533 72.2145C63.9188 71.9799 63.8015 71.6833 63.8015 71.3245V70.1656C63.0564 70.0966 62.3735 69.9379 61.7526 69.6896C61.1455 69.4412 60.5522 69.0687 59.9727 68.572C59.6002 68.2408 59.414 67.8752 59.414 67.4751C59.414 67.1578 59.5312 66.8818 59.7658 66.6473C60.0003 66.3989 60.2832 66.2747 60.6143 66.2747C60.8765 66.2747 61.111 66.3575 61.318 66.5231C61.7457 66.868 62.1527 67.144 62.539 67.3509C62.9254 67.5441 63.3462 67.6752 63.8015 67.7441V63.7084C61.0282 63.1979 59.6416 61.8113 59.6416 59.5486C59.6416 58.4034 60.0279 57.4652 60.8006 56.7339C61.5732 55.9889 62.5735 55.5336 63.8015 55.368V54.685C63.8015 54.3263 63.9188 54.0297 64.1533 53.7951C64.4017 53.5468 64.7052 53.4226 65.0639 53.4226C65.4089 53.4226 65.6986 53.5468 65.9332 53.7951C66.1677 54.0297 66.285 54.3263 66.285 54.685V55.4508C67.4578 55.6577 68.4236 56.0855 69.1824 56.7339C69.5825 57.0513 69.7826 57.4169 69.7826 57.8308C69.7826 58.1481 69.6653 58.431 69.4308 58.6793C69.1962 58.9139 68.9203 59.0312 68.6029 59.0312C68.396 59.0312 68.2097 58.9691 68.0441 58.8449C67.6302 58.5 67.0438 58.2033 66.285 57.955V61.7837C67.6233 62.1011 68.596 62.5702 69.2031 63.191C69.8102 63.7981 70.1137 64.695 70.1137 65.8815ZM62.0837 59.4451C62.0837 59.9004 62.2286 60.2729 62.5183 60.5627C62.8081 60.8386 63.2358 61.0594 63.8015 61.2249V57.7894C63.2358 57.8998 62.8081 58.0999 62.5183 58.3896C62.2286 58.6793 62.0837 59.0312 62.0837 59.4451ZM66.285 67.5579C66.6851 67.3923 67.0093 67.1785 67.2577 66.9163C67.506 66.6404 67.6302 66.3437 67.6302 66.0264C67.6302 65.6401 67.5198 65.3089 67.2991 65.033C67.0783 64.7432 66.7403 64.5018 66.285 64.3086V67.5579Z"
        fill="currentColor"
      />
      <path
        d="M37 30C43.8 30.0005 55.2687 32.2498 71 30"
        stroke="currentColor"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M36 41C38.5 40.9994 47 41.6217 54 41"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M38 68.1456C41 67.6113 45 68.7673 52 68.1456"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M38 61.1456C41 60.6113 45 61.7673 52 61.1456"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M60 41C65.6738 40.9995 65 41.6325 72 41.0107"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol fill="none" viewBox="0 0 88 88" id="automatic_scan_request" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.882 79.059c-.117.588.236 1.059.824 1.294.588.235 1.176.588 1.765.706v-.118c.117.118 36.352 2 54.705 1.53.353 0 .706-.236.824-.706 2-8.706.941-20.706 0-31.294-.824-9.412-1.412-15.177-.706-26-.118-.706-.118-.471-.235-.706-2.236-4.942-5.883-8.942-10.941-12.236-.118-.117-.236-.117-.471-.117-.118 0-.353-.118-.353-.118-21.882-1.412-30.941 2.353-41.765-2-.235-.118-.47 0-.823.118l-.118.117v-.353c-.353 1.06-1.294 2.471-2.118 3.177-3.529 22.235 2.706 37.412-.588 66.706Zm55.06-55.647H60.47c-.236 0-.353-.118-.353-.353v-9.412c3.882 2.706 6.823 5.882 8.823 9.765ZM18 11.412c10.941 3.764 19.412.353 40.235 1.53v10.117c0 1.176.941 2 2 2.117.353.236.706.471 1.177.589 4.235 1.411 6.353 1.882 7.647 7.529-.118 15.059 3.882 34.353 1.176 47.412C52.471 81.176 36 80 17.647 79.294c-.353-5.647 1.412-16.588 1.765-21.882.353-4.47-.236-8.941-.824-13.294-1.647-11.765-1.294-19.295-.588-32.706ZM69.618 13.375l3.765-7.059c.588-1.059-.941-1.882-1.53-.824l-3.764 7.06c-.47 1.058 1.059 1.882 1.53.823ZM72.183 17.306l5.49-2.285c1.112-.384.535-2.052-.577-1.668l-5.49 2.285c-1.076.272-.5 1.94.577 1.668Z" fill="#8E8BAA"/>
      <path opacity=".5" fill="#F6F4FB" d="m7.697 32.9 68.067-1.556.692 30.252-68.067 1.556z"/>
      <path d="m25.7 63.838 14.046-.322m8.643-.197 9.184-.21M24.959 31.425l14.046-.322m8.643-.197 9.184-.21M7.907 42.084l-.175-7.659a3 3 0 0 1 3.073-3.067l8.212.203M76.514 40.515l-.175-7.659a3 3 0 0 0-3.21-2.924l-8.195.579M8.166 53.428l.175 7.66a3 3 0 0 0 3.21 2.923l8.194-.578M76.773 51.86l.176 7.659a3 3 0 0 1-3.074 3.067l-8.211-.203" stroke="#8E8BAA" stroke-width="2.4" stroke-linecap="round"/>
      <path d="M39.382 59.476c.373.068.73.107 1.113.193 4.17-4.112 8.272-8.306 12.54-12.316-.05-.537-.04-.715-.036-1.155a.286.286 0 0 0-.25-.455c-2.075.136-4.194.137-7.206.272.504-2.029 2.416-10.301 2.435-10.39.06-.284-.29-.47-.49-.26-1.822 1.897-12.422 12.21-12.46 12.245a.288.288 0 0 0 .082.47c.118.434.328.841.623 1.179 1.91.157 3.82.304 5.73.46-1.023 3.19-1.832 6.427-2.556 9.481a.287.287 0 0 0 .475.276Zm3.043-11.185a.29.29 0 0 0-.216-.128c-.724-.063-3.853-.21-6.355-.548.038-.036 10.578-10.326 11.332-11.105-2.377 10.336-2.38 9.772-2.26 9.965.056.088.154.14.259.134 2.392-.113 5.287-.164 6.861-.247-3.922 4.03-8.38 7.912-12.333 11.948 2.267-9.428 2.951-9.657 2.712-10.02Z" fill="#8E8BAA" stroke="#8E8BAA"/>
    </symbol>
    <symbol fill="none" viewBox="0 0 88 88" id="automatic_forwarding" xmlns="http://www.w3.org/2000/svg">
      <path d="m30.25 16.7 1.357-8.547c.228-1.29-1.627-1.593-1.854-.302l-1.358 8.547c-.108 1.25 1.747 1.552 1.854.303ZM33.86 19.332l7.51-5.6c1.018-.764-.127-2.291-1.146-1.527l-7.51 5.6c-1.018.636.128 2.164 1.146 1.527ZM37.297 23.914l6.873-1.782c1.273-.254.764-2.163-.51-1.909l-6.872 1.782c-1.146.382-.764 2.291.509 1.91ZM81.148 40.645c-4.947-3.718-9.189-8.225-13.666-12.469-2.37-2.239-6.114-6.773-9.86-6.815-.27-.36-.656-.588-1.52-.415-.49.152-.843.546-.94 1.05-.588 2.902-.298 5.88-.133 8.866C44 29.976 31.491 36.158 23.108 42.486 13.88 49.36 7.128 62.922 7.907 74.732c.027.498.414.726.794.83.394.352.899.449 1.382.172 13.865-10.998 28.295-23.363 46.752-21.266l.124-.007c-.92 3.67-.817 7.781-.61 11.513.062 1.12 1.078 1.438 1.817 1.272.4.477 1.292.802 1.88.145 7.83-7.296 16.36-15.503 21.316-25.135.353-.394.305-1.265-.213-1.61Zm-3.919 3.586c-1.942 3.227-4.527 6.115-7.112 9.003-3.525 3.938-7.575 7.406-10.97 11.462-.185-3.358-.495-6.71-.44-10.207-.02-.373-.158-.615-.414-.725.332-.767.153-1.755-.856-1.95-18.25-2.857-34.318 9.224-47.643 20.942 1.26-11.05 7.148-22.193 16.133-28.929 8.985-6.736 18.618-8.517 29.247-10.353l.007.125c-.07 1.002 1.554 1.036 1.755.152-.014-.249.103-.38.09-.629.725-.414.919-1.423.276-1.762.263-2.01.278-4.008.416-6.012-.02-.373.07-1.002.16-1.63 1.734 2.024 4.574 3.739 6.543 5.501 3.813 3.532 7.392 7.326 11.33 10.852 2.087 1.631 2.958 1.583 1.478 4.16Z" fill="#8E8BAA"/>
      <circle cx="20.228" cy="34.89" r="14.728" fill="#F6F4FB" stroke="#8E8BAA" stroke-width="3"/>
      <path d="M16.057 44.928c.309.056.604.089.921.16 3.452-3.403 6.846-6.874 10.378-10.193-.04-.444-.032-.591-.03-.956a.237.237 0 0 0-.207-.377c-1.717.113-3.47.114-5.963.226.417-1.68 2-8.525 2.015-8.6.05-.234-.24-.387-.406-.214-1.507 1.57-10.28 10.105-10.31 10.134a.239.239 0 0 0 .067.39c.097.358.27.695.515.975 1.58.13 3.161.25 4.742.38-.846 2.64-1.516 5.319-2.115 7.847a.237.237 0 0 0 .393.228Zm2.518-9.257a.24.24 0 0 0-.178-.106c-.6-.052-3.189-.173-5.26-.453.031-.03 8.755-8.546 9.379-9.19-1.967 8.554-1.97 8.087-1.87 8.246a.237.237 0 0 0 .213.112c1.98-.094 4.376-.136 5.679-.205-3.246 3.334-6.935 6.548-10.207 9.888 1.876-7.803 2.442-7.992 2.244-8.292Z" fill="#8E8BAA" stroke="#8E8BAA"/>
    </symbol>
  </svg>
</template>

<script>
export default {
  name: "extras-svgs"
};
</script>
